define(
    'AG.CustomFunctions'
    , [
        'LiveOrder.Model',
        'underscore'
    ]
    , function (
        LiveOrderModel,
        _
    ) {
        'use strict';

        return {
            checkAndNotifyESDBilling: function () {
                var self = this;

                var cartItems = self.getCartItems();
                if (self.cartContainsBothESDAndNonESD(cartItems)) {
                    self.showBillingWarning(cartItems);
                }
            },

            getCartItems: function () {
                var cartModel = LiveOrderModel.getInstance();
                var cartLines = cartModel.get("lines").models;
                var cartItems = [];

                for (var i = 0; i < cartLines.length; i++) {
                    var item = cartLines[i].get("item");
                    var itemId = item.get("itemid");
                    var displayName = item.get("displayname");
                    var isESD = item.get("custitem_is_esd") == "Yes";

                    cartItems.push({
                        itemId: itemId,
                        displayName: displayName,
                        isESD: isESD
                    });
                }

                return cartItems;
            },

            cartContainsBothESDAndNonESD: function (cartItems) {
                var containsESD = _.filter(cartItems, function (item) {
                    return item.isESD;
                }).length > 0;
                var containsNonESD = _.filter(cartItems, function (item) {
                    return !item.isESD;
                }).length > 0;
                var containsBoth = containsESD && containsNonESD;

                return containsBoth;
            },

            showBillingWarning: function (cartItems) {
                var ESDItemsLength = _.filter(cartItems, function (item) {
                    return item.isESD;
                }).length;
                var message = "Because your order contains " + ESDItemsLength + " ESD item(s) in addition to one or more hardware items, your entire order will be billed immediately. "
                    + "If you would like to be billed separately for ESD and hardware items, please place multiple orders. "
                    + "Click OK to continue with immediate billing, or click Cancel to be taken back to your cart."

                if (!confirm(message)) {
                    var touchpoints = SC.getSessionInfo('touchpoints');
                    window.location = touchpoints.viewcart;
                }
            }
        };
    });
